module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "faq-page faq-content-1"
  }, [_c('div', {
    staticClass: "faq-content-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("User Preferences")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion1"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_1"
    }
  }, [_vm._v(" How do I update my user profile?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click your "), _c('b', [_vm._v("Profile Photo")]), _vm._v(" icon > click "), _c('b', [_vm._v("My Profile")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Edit the My Profile page.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save Changes")]), _vm._v(".")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_2"
    }
  }, [_vm._v(" How do I update my Profile Photo?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click your "), _c('b', [_vm._v("Profile Photo")]), _vm._v(" icon > click "), _c('b', [_vm._v("My Profile")]), _vm._v(" > click "), _c('b', [_vm._v("Upload\n                                Avatar")]), _vm._v(".\n                              ")]), _vm._v(" "), _c('li', [_vm._v("Browse and upload your new image.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "faqnote"
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" The logo file should be .jpg, .png or .gif format.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_3"
    }
  }, [_vm._v(" How do I change my password?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click your "), _c('b', [_vm._v("Profile Photo")]), _vm._v(" > click "), _c('b', [_vm._v("My Profile")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Click the "), _c('b', [_vm._v("Change Password")]), _vm._v(" tab.")]), _vm._v(" "), _c('li', [_vm._v("Enter your current password in the Current Password field > enter your new password\n                                in both the New Password and Confirm New Password fields.\n                              ")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save Changes")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "faqnote"
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" The password must meet the following requirements: 6 -16 characters.\n                              Combine a minimum of one upper and lowercase letter, number, special character\n                              (!@#$%^&*()) and cannot include your first or last name.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_4"
    }
  }, [_vm._v(" How do I reset my password?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Visit "), _c('b', [_vm._v("www.casemgrsolutions.org")]), _vm._v(" or your CaseMGR URL.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Forgot Password")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Enter the email address associated to your CaseMGR account.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Submit")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Check your email inbox for a new message from CaseMGR.")]), _vm._v(" "), _c('li', [_vm._v("In the Password Reset page, enter your new password in both the New Password and\n                                Confirm New Password fields.\n                              ")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Submit")]), _vm._v(".")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_6"
    }
  }, [_vm._v(" Do temporary passwords expire?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_6"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Yes, temporary passwords expire after two hours.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_7"
    }
  }, [_vm._v(" How do I update my email address?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_7"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Only users with administrator privilege can update a user’s email address. Contact your\n                              manager for assistance.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_8"
    }
  }, [_vm._v(" How do I set the Time Zone?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_8"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click your "), _c('b', [_vm._v("Profile Photo")]), _vm._v(" icon > click "), _c('b', [_vm._v("Time Zone Settings")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Select your time zone.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save Changes")]), _vm._v(".")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_9"
    }
  }, [_vm._v(" I have access to multiple CaseMGR workspaces, how do I switch\n                              between my workspaces?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_9"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Hover over "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("View As")])]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Set as Default")]), _vm._v(" on the organization you want to manage. CaseMGR will\n                                automatically sign you into the selected CaseMGR workspace.\n                              ")])]), _vm._v(" "), _c('p', {
    staticClass: "faqnote"
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" Only users with access to multiple CaseMGR workspaces have access to the\n                              View As menu option. Contact your manager for assistance if you believe there is an\n                              error.")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("User Preferences - Administrative")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion3"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion3",
      "href": "#collapse_3_1"
    }
  }, [_vm._v(" How do I update a user’s profile?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_3_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Hover over "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > click\n                                the corresponding user under the user table.\n                              ")]), _vm._v(" "), _c('li', [_vm._v("Edit the My Profile page.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save Changes")]), _vm._v(".")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion3",
      "href": "#collapse_3_2"
    }
  }, [_vm._v(" How do I update a user’s email address?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_3_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > click\n                                the corresponding user under the user table.\n                              ")]), _vm._v(" "), _c('li', [_vm._v("Edit the email address.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save Changes")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "faqnote"
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" Only users with administrator privilege can update a user’s email address.\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("Managing Access - Administrative")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion10"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_1"
    }
  }, [_vm._v(" Who can manage a user’s access?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" Access can only be managed by a Program Administrator.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_2"
    }
  }, [_vm._v(" How do I add a user?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the Administrative Settings icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Enter the user’s Full Name and Email Address.")]), _vm._v(" "), _c('li', [_vm._v("Assign the user access by clicking the corresponding Yes radio button.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Create User")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("An invitation will be sent to the email address provided. The Last Login date will\n                                display once the user accepts the invitation and signs into to CaseMGR.\n                              ")])]), _vm._v(" "), _c('p', {
    staticClass: "faqnote"
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" The Full Name should be entered as the First Name and Last Name. For example,\n                              John Doe.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_3"
    }
  }, [_vm._v(" The system will not allow me to add a new user.")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Confirm the following:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Have you been granted with Program Administrator access? Only users with administrator privilege can add users.")]), _vm._v(" "), _c('li', [_vm._v("The user you are trying to add already has access to your CaseMGR account.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_4"
    }
  }, [_vm._v(" What do I do if the user did not receive their invitation to CaseMGR?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > search for the corresponding user under the user table > Click "), _c('b', [_vm._v("Resend Activation")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("The system will resend the invitation to the email address provided. The Last Login date will display once the user accepts the invitation and signs into CaseMGR.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_5"
    }
  }, [_vm._v(" The Resend Activation link is not displaying under my user table.")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_5"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("The Resend Activation link will only display if the user has not accepted their invitation to CaseMGR. The Last Login column will be empty until the user has signed into CaseMGR.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_6"
    }
  }, [_vm._v(" How do I modify user permissions?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_6"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > click the corresponding user under the user table.")]), _vm._v(" "), _c('li', [_vm._v("Click the "), _c('b', [_vm._v("User Access")]), _vm._v(" tab > select the user access by clicking the corresponding Yes radio button.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save Changes")]), _vm._v(".")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_7"
    }
  }, [_vm._v(" How do I activate a user?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_7"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > search for the corresponding user under the user table > click "), _c('b', [_vm._v("Activate")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("The user will be activated and be able to access CaseMGR.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_8"
    }
  }, [_vm._v(" How do I disable a user?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_8"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > search for the corresponding user under the user table > click "), _c('b', [_vm._v("Disable")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("The user will be disabled and automatically logged out.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_9"
    }
  }, [_vm._v(" What happens when I disable a user?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_9"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("The user will be automatically logged out and will no longer be able to access CaseMGR.")]), _vm._v(" "), _c('li', [_vm._v("The Access Action status will display Activate.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_10"
    }
  }, [_vm._v(" How do I delete a user?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_10"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Users can be deactivated, but never deleted.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion10",
      "href": "#collapse_10_11"
    }
  }, [_vm._v(" How do I view a user’s last login?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_10_11"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Click the "), _c('b', [_vm._v("Administrative Settings")]), _vm._v(" icon > click "), _c('b', [_vm._v("Manage Users")]), _vm._v(" > search for the corresponding user under the user table.")]), _vm._v(" "), _c('li', [_vm._v("The user’s last login will display under the Last Login column.")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("Managing Participants and Forms")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion2"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#collapse_2_1"
    }
  }, [_vm._v(" How do I update a participant’s photo?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ol', [_c('li', [_vm._v("Search for the desired participant > click the "), _c('b', [_vm._v("View | Edit")]), _vm._v(" that is located on the\n                                Standard Demographics section > click "), _c('b', [_vm._v("Upload Image")]), _vm._v(".\n                              ")]), _vm._v(" "), _c('li', [_vm._v("Browse and upload the new image.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Save")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "faqnote"
  }, [_vm._v("NOTE: The logo file should be .jpg, .png or .gif format.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#collapse_2_2"
    }
  }, [_vm._v(" What happens if I close a participant’s case?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("With the exception of the Program Status, CaseMGR will allow you to edit the\n                              Participant’s Profile, Primary Contact and Assignment page.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#collapse_2_3"
    }
  }, [_vm._v(" How do I reopen my participant’s case?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2_3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" The system will not allow you to reopen a Participant’s case. Contact your manager as\n                              you may be required to add a "), _c('b', [_vm._v("New Assignment")]), _vm._v(".")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#collapse_2_4"
    }
  }, [_vm._v(" How do I configure forms?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2_4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" Only users with administrator privilege can configure forms.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#collapse_2_5"
    }
  }, [_vm._v(" The form I was completing has disappeared.")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2_5"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" The form may have been unpublished by the Program Administrator. Please contact your\n                              manager for assistance.")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("Account and Billing - Administrative")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion4"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion4",
      "href": "#collapse_4_1"
    }
  }, [_vm._v(" How do I update the Billing or Program contact?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_4_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" Please contact Customer Support at "), _c('a', {
    attrs: {
      "href": "mailto:support@casemgrsolutions.com"
    }
  }, [_vm._v("support@casemgrsolutions.com")]), _vm._v(".\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion4",
      "href": "#collapse_4_2"
    }
  }, [_vm._v(" How do I update my billing details?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_4_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" Please contact Customer Support at "), _c('a', {
    attrs: {
      "href": "mailto:support@casemgrsolutions.com"
    }
  }, [_vm._v("support@casemgrsolutions.com")]), _vm._v(".\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion4",
      "href": "#collapse_4_3"
    }
  }, [_vm._v(" Can I have an invoice for my subscription?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_4_3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" Please contact Customer Support at "), _c('a', {
    attrs: {
      "href": "mailto:support@casemgrsolutions.com"
    }
  }, [_vm._v("support@casemgrsolutions.com")]), _vm._v(".\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("Troubleshooting")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion6"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion6",
      "href": "#collapse_6_1"
    }
  }, [_vm._v(" Browser and System Requirements")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_6_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" We recommend using the up-to-date browser version of Chrome, Firefox, or Safari. To\n                              confirm if you are using the latest version visit http://whatbrowser.org/. ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion6",
      "href": "#collapse_6_2"
    }
  }, [_vm._v(" Slow Processing")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_6_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" If you notice that CaseMGR is processing slowly, please confirm your internet\n                              connectivity. If you continue to experience issues, you can run a connection test and\n                              email your results to support@casemgrsolutions.com.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion6",
      "href": "#collapse_6_3"
    }
  }, [_vm._v(" How do I run a connection test?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_6_3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" To run a connection test visit http://www.speedtest.net/. ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion6",
      "href": "#collapse_6_4"
    }
  }, [_vm._v(" Do I need special software to use CaseMGR?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_6_4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" No, CaseMGR is web-based therefore all you need is an internet connect and a web\n                              browser.")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-section"
  }, [_c('h2', {
    staticClass: "faq-title uppercase"
  }, [_vm._v("Customer Support")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion faq-content",
    attrs: {
      "id": "accordion5"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion4",
      "href": "#collapse_5_1"
    }
  }, [_vm._v(" How do I contact Customer Support?")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_5_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v(" Contact Customer Support at "), _c('a', {
    attrs: {
      "href": "mailto:support@casemgrsolutions.com"
    }
  }, [_vm._v("support@casemgrsolutions.com")]), _vm._v(".\n                            ")])])])])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01755041","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Faq.vue
// module id = 1534
// module chunks = 1